// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".track-catalog{float:left;position:relative;border:1px solid #c3c4be;border-radius:3px;width:100%;min-height:284px;padding:10px}.track-catalog__close{display:block;position:absolute;top:10px;right:10px;width:16px;height:16px;fill:#c3c4be;cursor:pointer}.track-catalog__close svg{display:block;width:100%;height:100%}.track-catalog__list{float:left;width:100%;margin-top:10px}", ""]);
// Exports
module.exports = exports;
